/** Halloween browser-tab icon (created from chaos-kitchen-halloween-logo.webp). */
import { creepyStage } from "./creepyStage.ts";

export const HALLOWEEN_ICON_HREF = "/icons/icon-halloween-512.png";
export const HALLOWEEN_TOUCH_ICON_HREF = "/icons/icon-halloween-180.png";
export const DEFAULT_ICON_HREF = "/chaos-kitchen-logo.png";
export const DEFAULT_TOUCH_ICON_HREF = "/icons/apple-touch-icon.png";

/**
 * Halloween icon while the Halloween theme is on (Oct 1 – Nov 1 06:00 Copenhagen,
 * the same deadline as the site-wide theme). Returns null outside the season.
 */
export function seasonalIconHref(stage: number): string | null {
  return stage > 0 ? HALLOWEEN_ICON_HREF : null;
}

function setLinks(href: string | null) {
  const iconHref = href ?? DEFAULT_ICON_HREF;
  const touchHref = href ? HALLOWEEN_TOUCH_ICON_HREF : DEFAULT_TOUCH_ICON_HREF;
  for (const link of document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]')) {
    if (link.getAttribute("href") !== iconHref) {
      link.setAttribute("href", iconHref);
      link.setAttribute("type", "image/png");
    }
  }
  for (const link of document.querySelectorAll<HTMLLinkElement>('link[rel="apple-touch-icon"]')) {
    if (link.getAttribute("href") !== touchHref) link.setAttribute("href", touchHref);
  }
}

/** Applies the seasonal icon to the current document and returns the href used (null = default). */
export function applySeasonalFavicon(now: Date = new Date()): string | null {
  const href = seasonalIconHref(creepyStage(now));
  setLinks(href);
  return href;
}
